// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.Sidebar_sidebar__B3hTp {
  background: #F7F5F1;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  padding: 18px 14px 14px;
  display: flex;
  flex-direction: column;
  height: calc(100dvh - 40px);
  position: sticky;
  top: 20px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
  z-index: 1001;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
}
@media (max-width: 1024px) {
  .Sidebar_sidebar__B3hTp {
    position: fixed !important;
    left: -280px;
    top: 0 !important;
    height: 100dvh !important;
    width: 260px !important;
    border-radius: 0 !important;
    z-index: 2000 !important;
    background: #F7F5F1 !important;
    transition: left 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
    padding-top: 24px;
    box-shadow: 20px 0 50px rgba(0, 0, 0, 0.1);
  }
  .Sidebar_sidebar__B3hTp:not(.Sidebar_sidebar-closed__j5Xyv) {
    left: 0 !important;
  }
  .Sidebar_sidebar__B3hTp.Sidebar_sidebar-closed__j5Xyv {
    left: -280px !important;
    width: 260px !important;
  }
}
.Sidebar_sidebar__B3hTp.Sidebar_sidebar-closed__j5Xyv {
  width: 80px;
  padding: 18px 10px 14px;
}
.Sidebar_sidebar__B3hTp.Sidebar_sidebar-closed__j5Xyv .Sidebar_sidebar__label__9mCqC, .Sidebar_sidebar__B3hTp.Sidebar_sidebar-closed__j5Xyv .Sidebar_sidebar__accordion-summary__YOgZB, .Sidebar_sidebar__B3hTp.Sidebar_sidebar-closed__j5Xyv .Sidebar_sidebar__user-info__ntg8r {
  display: none;
}
.Sidebar_sidebar__B3hTp.Sidebar_sidebar-closed__j5Xyv .Sidebar_sidebar__brand__W0U01 {
  justify-content: center;
  padding: 4px 0;
  margin-bottom: 24px;
}
.Sidebar_sidebar__B3hTp.Sidebar_sidebar-closed__j5Xyv .Sidebar_sidebar__menu-item__SZDcz {
  justify-content: center;
  padding: 12px 0;
  border-radius: 12px;
}
.Sidebar_sidebar__B3hTp.Sidebar_sidebar-closed__j5Xyv .Sidebar_sidebar__logout__AATr8 {
  justify-content: center;
  border: none;
  background: transparent;
  box-shadow: none;
}
.Sidebar_sidebar__B3hTp.Sidebar_sidebar-closed__j5Xyv .Sidebar_sidebar__accordion__SXG9X {
  margin-bottom: 16px;
}
.Sidebar_sidebar__B3hTp.Sidebar_sidebar-closed__j5Xyv .Sidebar_sidebar__accordion--consultant__0yGTg {
  background: transparent;
  box-shadow: none;
}
.Sidebar_sidebar__B3hTp.Sidebar_sidebar-closed__j5Xyv .Sidebar_sidebar__accordion--consultant__0yGTg .Sidebar_sidebar__nav__YBCro {
  padding: 0;
  margin: 0;
}
.Sidebar_sidebar__brand__W0U01 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 24px;
  padding: 4px 6px;
  text-decoration: none;
}
.Sidebar_sidebar__logo-img__dRK-5 {
  max-width: 140px;
  height: auto;
}
.Sidebar_sidebar__brand-mark__stL1Y {
  width: 32px;
  height: 32px;
  background-size: cover;
  background-position: left center;
  background-repeat: no-repeat;
}
.Sidebar_sidebar__accordion__SXG9X {
  margin-bottom: 4px;
}
.Sidebar_sidebar__accordion--consultant__0yGTg {
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(214, 166, 64, 0.035), rgba(214, 166, 64, 0.018));
  box-shadow: inset 0 0 0 1px rgba(214, 166, 64, 0.1);
}
.Sidebar_sidebar__accordion--consultant__0yGTg .Sidebar_sidebar__accordion-summary__YOgZB {
  width: 100%;
  min-height: 32px;
  margin: 0;
  padding: 4px 10px 6px;
}
.Sidebar_sidebar__accordion--consultant__0yGTg .Sidebar_sidebar__accordion-label__rx-xq,
.Sidebar_sidebar__accordion--consultant__0yGTg .Sidebar_sidebar__accordion-symbol__4MAFt {
  color: rgba(122, 93, 26, 0.78);
}
.Sidebar_sidebar__accordion--consultant__0yGTg .Sidebar_sidebar__nav__YBCro {
  margin: 2px 0 0;
  padding: 0 4px 6px;
}
.Sidebar_sidebar__accordion--consultant__0yGTg .sidebar__menu-item:hover {
  background: rgba(214, 166, 64, 0.045);
  border: 1px solid transparent;
}
.Sidebar_sidebar__nav__YBCro {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.Sidebar_sidebar__accordion-summary__YOgZB {
  list-style: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 8px 2px 8px;
  padding-right: 4px;
}
.Sidebar_sidebar__accordion-summary__YOgZB::-webkit-details-marker {
  display: none;
}
.Sidebar_sidebar__accordion-label__rx-xq {
  color: rgba(19, 35, 29, 0.6784313725);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.Sidebar_sidebar__accordion-symbol__4MAFt {
  color: rgba(19, 35, 29, 0.6784313725);
  font-size: 14px;
  font-weight: 600;
}
.Sidebar_sidebar__accordion-symbol__4MAFt::before {
  content: "+";
}
.Sidebar_sidebar__accordion__SXG9X[open] .Sidebar_sidebar__accordion-symbol__4MAFt::before {
  content: "−";
}
.Sidebar_sidebar__divider__t7\\+K8 {
  height: 1px;
  background: rgba(16, 25, 21, 0.08);
  margin: 8px 8px;
}
.Sidebar_sidebar__menu__zVLaB {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-right: 4px;
  overflow-x: hidden;
  padding-bottom: 16px;
}
.Sidebar_sidebar__menu__zVLaB::-webkit-scrollbar {
  width: 4px;
}
.Sidebar_sidebar__menu__zVLaB::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}
.Sidebar_sidebar__menu-item__SZDcz {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1px;
  padding: 10px 12px;
  border-radius: 12px;
  color: #334239;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  text-decoration: none;
}
.Sidebar_sidebar__menu-item__SZDcz:hover {
  background: rgba(130, 177, 148, 0.1);
}
.Sidebar_sidebar__menu-item--active__h4CiA {
  background: rgba(130, 177, 148, 0.12) !important;
  border: 1px solid rgba(130, 177, 148, 0.42) !important;
  color: #13231D !important;
  font-weight: 800 !important;
}
.Sidebar_sidebar__menu-item--disabled__nNzmz {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
  font-weight: 400 !important;
  color: #596860 !important;
}
.Sidebar_sidebar__item-left__ERg3o {
  display: flex;
  align-items: center;
  gap: 12px;
}
.Sidebar_sidebar__icon__toMFr {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 22px;
  color: inherit;
}
.Sidebar_sidebar__icon__toMFr svg {
  font-size: 20px !important;
}
.Sidebar_sidebar__label__9mCqC {
  white-space: normal;
}
.Sidebar_sidebar__alert-dot__m3-bB {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(214, 166, 64, 0.18);
  color: #7a5710;
  font-size: 14px;
  font-weight: 900;
  display: grid;
  place-items: center;
}
.Sidebar_sidebar__footer__hXnRr {
  margin-top: auto;
  padding-top: 10px;
}
.Sidebar_sidebar__user-info__ntg8r {
  margin: 10px 8px 12px;
  font-size: 12px;
  color: rgba(19, 35, 29, 0.68);
  font-weight: 500;
}
.Sidebar_sidebar__logout__AATr8 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  min-height: 42px;
  border-radius: 12px;
  border: 1px solid rgba(16, 25, 21, 0.1);
  background: rgba(247, 245, 241, 0.68);
  font-weight: 700;
  color: #13231D;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s;
}
.Sidebar_sidebar__toggle-container__4cVcy {
  position: absolute;
  right: -12px;
  top: 60px;
  z-index: 10;
  display: none;
}
@media (max-width: 1024px) {
  .Sidebar_sidebar__toggle-container__4cVcy {
    display: block;
  }
}
.Sidebar_sidebar__toggle-btn__j3qSY {
  width: 24px;
  height: 24px;
  background: #fff;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  transition: transform 0.3s;
}
.Sidebar_sidebar__toggle-btn__j3qSY.Sidebar_is-open__nhevp {
  transform: rotate(0deg);
}
.Sidebar_sidebar__toggle-btn__j3qSY.Sidebar_is-closed__nHuIw {
  transform: rotate(180deg);
}
.Sidebar_sidebar__logout-icon__JYiUe {
  font-weight: 400;
}
@media print {
  .Sidebar_sidebar__B3hTp {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/dashboard-layouts/style/Sidebar.module.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACyIhB;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AD5IJ;;AATA;EACI,mBCUmB;EDTnB,wCAAA;EACA,mBAAA;EACA,2CCsDU;EDrDV,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;EACA,SAAA;EACA,mDAAA;EACA,2BAAA;EACA,aAAA;EACA,2CAAA;AAYJ;AAVI;EAhBJ;IAiBQ,0BAAA;IACA,YAAA;IACA,iBAAA;IACA,yBAAA;IACA,uBAAA;IACA,2BAAA;IACA,wBAAA;IACA,8BAAA;IACA,8DAAA;IACA,iBAAA;IACA,0CAAA;EAaN;EAXM;IACI,kBAAA;EAaV;EAVM;IACI,uBAAA;IACA,uBAAA;EAYV;AACF;AATI;EACI,WAAA;EACA,uBAAA;AAWR;AAVQ;EACI,aAAA;AAYZ;AAVQ;EAAkB,uBAAA;EAAyB,cAAA;EAAgB,mBAAA;AAenE;AAdQ;EAAsB,uBAAA;EAAyB,eAAA;EAAiB,mBAAA;AAmBxE;AAlBQ;EAAmB,uBAAA;EAAyB,YAAA;EAAc,uBAAA;EAAyB,gBAAA;AAwB3F;AAtBQ;EACI,mBAAA;AAwBZ;AAvBY;EACI,uBAAA;EACA,gBAAA;AAyBhB;AAxBgB;EAAgB,UAAA;EAAY,SAAA;AA4B5C;AApBI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAsBR;AAnBI;EACI,gBAAA;EACA,YAAA;AAqBR;AAlBI;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gCAAA;EACA,4BAAA;AAoBR;AAjBI;EACI,kBAAA;AAmBR;AAjBQ;EACI,WAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,yFAAA;EACA,mDAAA;AAmBZ;AAjBY;EACI,WAAA;EACA,gBAAA;EACA,SAAA;EACA,qBAAA;AAmBhB;AAhBY;;EAEI,8BAAA;AAkBhB;AAfY;EACI,eAAA;EACA,kBAAA;AAiBhB;AAbY;EACI,qCAAA;EACA,6BAAA;AAehB;AAVI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAYR;AATI;EACI,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AAWR;AATQ;EACI,aAAA;AAWZ;AAPI;EACI,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AASR;AANI;EACI,qCAAA;EACA,eAAA;EACA,gBAAA;AAQR;AAPQ;EACI,YAAA;AASZ;AALI;EACI,YAAA;AAOR;AAJI;EACI,WAAA;EACA,kCAAA;EACA,eAAA;AAMR;AAHI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACI,gBAAA;EACA,iCAAA;EACJ,kBAAA;EACA,kBAAA;EACI,oBAAA;AAKZ;AAHQ;EAAuB,UAAA;AAM/B;AALQ;EAA6B,+BAAA;EAA8B,mBAAA;AASnE;AANI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;AAQR;AANQ;EACI,oCAAA;AAQZ;AALQ;EACI,gDAAA;EACA,sDAAA;EACA,yBAAA;EACA,2BAAA;AAOZ;AAJQ;EACI,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,2BAAA;EACA,yBAAA;AAMZ;AAFI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAIR;AADI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AAGR;AADQ;EACI,0BAAA;AAGZ;AACI;EACI,mBAAA;AACR;AAEI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAAR;AAGI;EACI,gBAAA;EACA,iBAAA;AADR;AAII;EACI,qBAAA;EACA,eAAA;EACA,6BCrPe;EDsPf,gBAAA;AAFR;AAKI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,uCAAA;EACA,qCAAA;EACA,gBAAA;EACA,cCrQe;EDsQf,WAAA;EACA,eAAA;EACA,oBAAA;AAHR;AAMI;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AAJR;AAMQ;EAPJ;IAQQ,cAAA;EAHV;AACF;AAMI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,2CCvPM;EDwPN,0BAAA;AAJR;AAMQ;EAAY,uBAAA;AAHpB;AAIQ;EAAc,yBAAA;AADtB;AAGI;EACI,gBAAA;AADR;AAII;EA3TJ;IA4TQ,wBAAA;EADN;AACF","sourcesContent":["@import '../../../assets/styles/variables';\n\n$bw-surface-glass: rgba(255, 255, 255, 0.58);\n$bw-border: rgba(12, 36, 28, 0.08);\n$bw-primary-soft: rgba(130, 177, 148, 0.12);\n$bw-primary-border: rgba(130, 177, 148, 0.42);\n$bw-shadow: $shadow-card;\n\n.sidebar {\n    background: $color-surface;\n    border: 1px solid $bw-border;\n    border-radius: 24px;\n    box-shadow: $bw-shadow;\n    padding: 18px 14px 14px;\n    display: flex;\n    flex-direction: column;\n    height: calc(100dvh - 40px);\n    position: sticky;\n    top: 20px;\n    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    backdrop-filter: blur(10px);\n    z-index: 1001; \n    box-shadow: 0 10px 30px rgba(0, 0, 0, .03);\n\n    @media (max-width: 1024px) {\n        position: fixed !important;\n        left: -280px;\n        top: 0 !important;\n        height: 100dvh !important;\n        width: 260px !important;\n        border-radius: 0 !important;\n        z-index: 2000 !important;\n        background: $color-surface !important; \n        transition: left 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;\n        padding-top: 24px;\n        box-shadow: 20px 0 50px rgba(0,0,0,0.1);\n\n        &:not(.sidebar-closed) {\n            left: 0 !important;\n        }\n\n        &.sidebar-closed {\n            left: -280px !important;\n            width: 260px !important; \n        }\n    }\n\n    &.sidebar-closed {\n        width: 80px;\n        padding: 18px 10px 14px;\n        .sidebar__label, .sidebar__accordion-summary, .sidebar__user-info {\n            display: none;\n        }\n        .sidebar__brand { justify-content: center; padding: 4px 0; margin-bottom: 24px; }\n        .sidebar__menu-item { justify-content: center; padding: 12px 0; border-radius: 12px; }\n        .sidebar__logout { justify-content: center; border: none; background: transparent; box-shadow: none; }\n        \n        .sidebar__accordion {\n            margin-bottom: 16px;\n            &--consultant {\n                background: transparent;\n                box-shadow: none;\n                .sidebar__nav { padding: 0; margin: 0; }\n            }\n        }\n\n        @media (max-width: 1024px) {\n        }\n    }\n\n    &__brand {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n        margin-bottom: 24px;\n        padding: 4px 6px;\n        text-decoration: none;\n    }\n\n    &__logo-img {\n        max-width: 140px;\n        height: auto;\n    }\n\n    &__brand-mark {\n        width: 32px;\n        height: 32px;\n        background-size: cover;\n        background-position: left center;\n        background-repeat: no-repeat;\n    }\n\n    &__accordion {\n        margin-bottom: 4px;\n\n        &--consultant {\n            width: 100%;\n            margin: 0;\n            padding: 0;\n            border: 0;\n            border-radius: 14px;\n            background: linear-gradient(180deg, rgba(214,166,64,.035), rgba(214,166,64,.018));\n            box-shadow: inset 0 0 0 1px rgba(214,166,64,.10);\n\n            .sidebar__accordion-summary {\n                width: 100%;\n                min-height: 32px;\n                margin: 0;\n                padding: 4px 10px 6px;\n            }\n\n            .sidebar__accordion-label,\n            .sidebar__accordion-symbol {\n                color: rgba(122,93,26,.78);\n            }\n\n            .sidebar__nav {\n                margin: 2px 0 0;\n                padding: 0 4px 6px;\n            }\n\n            // Target the item inside this accordion\n            :global(.sidebar__menu-item):hover {\n                background: rgba(214,166,64,.045);\n                border: 1px solid transparent; // assuming default is transparent\n            }\n        }\n    }\n\n    &__nav {\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n    }\n\n    &__accordion-summary {\n        list-style: none;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin: 8px 8px 2px 8px;\n        padding-right: 4px;\n        \n        &::-webkit-details-marker {\n            display: none;\n        }\n    }\n\n    &__accordion-label {\n        color: #13231dad;\n        font-size: 11px;\n        font-weight: 800;\n        letter-spacing: .16em;\n        text-transform: uppercase;\n    }\n\n    &__accordion-symbol {\n        color: #13231dad;\n        font-size: 14px;\n        font-weight: 600;\n        &::before {\n            content: '+';\n        }\n    }\n\n    &__accordion[open] &__accordion-symbol::before {\n        content: '−';\n    }\n\n    &__divider {\n        height: 1px;\n        background: rgba(16, 25, 21, 0.08); \n        margin: 8px 8px;\n    }\n\n    &__menu {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        flex: 1;\n            overflow-y: auto;\n            -webkit-overflow-scrolling: touch;\n        padding-right: 4px;\n        overflow-x: hidden;\n            padding-bottom: 16px;\n\n        &::-webkit-scrollbar { width: 4px; }\n        &::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.05); border-radius: 10px; }\n    }\n\n    &__menu-item {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 1px;\n        padding: 10px 12px;\n        border-radius: 12px;\n        color: #334239;\n        font-size: 14px;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        border: 1px solid transparent;\n        text-decoration: none;\n\n        &:hover {\n            background: rgba(130, 177, 148, 0.1);\n        }\n\n        &--active {\n            background: $bw-primary-soft !important;\n            border: 1px solid $bw-primary-border !important;\n            color: $text-main !important;\n            font-weight: 800 !important;\n        }\n\n        &--disabled {\n            opacity: 0.4;\n            cursor: not-allowed;\n            pointer-events: none;\n            font-weight: 400 !important;\n            color: #596860 !important;  \n        }\n    }\n\n    &__item-left {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n    }\n\n    &__icon {\n        width: 22px;\n        height: 22px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex: 0 0 22px;\n        color: inherit;\n\n        svg {\n            font-size: 20px !important;\n        }\n    }\n\n    &__label {\n        white-space: normal;\n    }\n\n    &__alert-dot {\n        width: 24px;\n        height: 24px;\n        border-radius: 50%;\n        background: rgba(214, 166, 64, 0.18);\n        color: #7a5710;\n        font-size: 14px;\n        font-weight: 900;\n        display: grid;\n        place-items: center;\n    }\n\n    &__footer {\n        margin-top: auto;\n        padding-top: 10px;\n    }\n\n    &__user-info {\n        margin: 10px 8px 12px;\n        font-size: 12px;\n        color: $text-secondary;\n        font-weight: 500;\n    }\n\n    &__logout {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 3px;\n        min-height: 42px;\n        border-radius: 12px;\n        border: 1px solid rgba(16, 25, 21, 0.1);\n        background: rgba($color-surface, 0.68);\n        font-weight: 700;\n        color: $text-main;\n        width: 100%;\n        cursor: pointer;\n        transition: all 0.2s;\n    }\n\n    &__toggle-container {\n        position: absolute;\n        right: -12px;\n        top: 60px;\n        z-index: 10;\n        display: none;\n\n        @media (max-width: 1024px) {\n            display: block;\n        }\n    }\n\n    &__toggle-btn {\n        width: 24px;\n        height: 24px;\n        background: #fff;\n        border: 1px solid $bw-border;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        box-shadow: $bw-shadow;\n        transition: transform 0.3s;\n        \n        &.is-open { transform: rotate(0deg); }\n        &.is-closed { transform: rotate(180deg); }\n    }\n    &__logout-icon {\n        font-weight: 400;\n    }\n\n    @media print {\n        display: none !important;\n    }\n}","\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves."],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `Sidebar_sidebar__B3hTp`,
	"sidebar-closed": `Sidebar_sidebar-closed__j5Xyv`,
	"sidebar__label": `Sidebar_sidebar__label__9mCqC`,
	"sidebar__accordion-summary": `Sidebar_sidebar__accordion-summary__YOgZB`,
	"sidebar__user-info": `Sidebar_sidebar__user-info__ntg8r`,
	"sidebar__brand": `Sidebar_sidebar__brand__W0U01`,
	"sidebar__menu-item": `Sidebar_sidebar__menu-item__SZDcz`,
	"sidebar__logout": `Sidebar_sidebar__logout__AATr8`,
	"sidebar__accordion": `Sidebar_sidebar__accordion__SXG9X`,
	"sidebar__accordion--consultant": `Sidebar_sidebar__accordion--consultant__0yGTg`,
	"sidebar__nav": `Sidebar_sidebar__nav__YBCro`,
	"sidebar__logo-img": `Sidebar_sidebar__logo-img__dRK-5`,
	"sidebar__brand-mark": `Sidebar_sidebar__brand-mark__stL1Y`,
	"sidebar__accordion-label": `Sidebar_sidebar__accordion-label__rx-xq`,
	"sidebar__accordion-symbol": `Sidebar_sidebar__accordion-symbol__4MAFt`,
	"sidebar__divider": `Sidebar_sidebar__divider__t7+K8`,
	"sidebar__menu": `Sidebar_sidebar__menu__zVLaB`,
	"sidebar__menu-item--active": `Sidebar_sidebar__menu-item--active__h4CiA`,
	"sidebar__menu-item--disabled": `Sidebar_sidebar__menu-item--disabled__nNzmz`,
	"sidebar__item-left": `Sidebar_sidebar__item-left__ERg3o`,
	"sidebar__icon": `Sidebar_sidebar__icon__toMFr`,
	"sidebar__alert-dot": `Sidebar_sidebar__alert-dot__m3-bB`,
	"sidebar__footer": `Sidebar_sidebar__footer__hXnRr`,
	"sidebar__toggle-container": `Sidebar_sidebar__toggle-container__4cVcy`,
	"sidebar__toggle-btn": `Sidebar_sidebar__toggle-btn__j3qSY`,
	"is-open": `Sidebar_is-open__nhevp`,
	"is-closed": `Sidebar_is-closed__nHuIw`,
	"sidebar__logout-icon": `Sidebar_sidebar__logout-icon__JYiUe`
};
export default ___CSS_LOADER_EXPORT___;
